import {
  EuiIcon,
  EuiSelectable,
  EuiSelectableProps,
} from "@inscopix/ideas-eui";

interface CellEditorFileBodyFilterProps {
  singleSelection: boolean;
  searchPlaceholder: string;
  isLoading?: boolean;
  errorMessage?: EuiSelectableProps["errorMessage"];
  checkedIcon: "arrow" | "check";
  options: (
    | {
        label: string;
        isGroupLabel: true;
      }
    | {
        key: string;
        data?: Record<string, unknown>;
        label: string;
        checked: boolean;
        isGroupLabel: false;
      }
  )[];
  renderOption?: EuiSelectableProps["renderOption"];
  onChange: EuiSelectableProps["onChange"];
}

export const CellEditorFileBodyFilter = ({
  singleSelection,
  searchPlaceholder,
  isLoading,
  errorMessage,
  checkedIcon,
  options,
  renderOption,
  onChange,
}: CellEditorFileBodyFilterProps) => {
  return (
    <EuiSelectable
      height="full"
      searchable
      singleSelection={singleSelection}
      isLoading={isLoading}
      renderOption={renderOption}
      errorMessage={errorMessage}
      options={options.map((option) => {
        if (option.isGroupLabel) {
          return option;
        } else {
          return {
            key: option.key,
            data: option.data,
            label: option.label,
            checked: option.checked ? "on" : undefined,
            prepend:
              option.checked && checkedIcon === "arrow" ? (
                <EuiIcon
                  aria-label="Selected"
                  size="s"
                  type="arrowRight"
                  color="text"
                />
              ) : undefined,
          };
        }
      })}
      listProps={{
        bordered: false,
        showIcons: checkedIcon === "check",
      }}
      searchProps={{
        compressed: true,
        placeholder: searchPlaceholder,
      }}
      onChange={onChange}
    >
      {(list, search) => (
        <>
          {search}
          {list}
        </>
      )}
    </EuiSelectable>
  );
};
